import React from 'react'
import TranslateText from 'translation/TranslateText';
import './package.css'; // Import CSS file for styling

function InquiryHeader() {
  return (
    <div>
      <div className="page-header-container">
      <div
        className="page-header section-dark"
        style={{
          backgroundImage: `url(${require("assets/img/Artboard1.png")})`,
          backgroundSize: "cover",
          backgroundPosition: "center -150px",
        }}
      >
         <div className="centered">
          <h1 className='age inq'><TranslateText text="Inquiry Removal"/></h1>
        </div>
       
      </div>
    </div>
    </div>
  )
}

export default InquiryHeader
